var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 68,
    viewBox: "0 0 34 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3744 38.1866V11.7204C28.3744 5.58398 23.3998 0.609375 17.2633 0.609375C11.1269 0.609375 6.15228 5.58398 6.15228 11.7204V38.1865C2.74251 41.2383 0.59668 45.6733 0.59668 50.6094C0.59668 59.8142 8.05866 67.276 17.2633 67.276C26.468 67.276 33.93 59.8142 33.93 50.6094C33.93 45.6733 31.7842 41.2383 28.3744 38.1866ZM17.2633 61.7204C11.1269 61.7204 6.15228 56.7458 6.15228 50.6094C6.15228 47.4014 7.51178 44.4255 9.85736 42.3262L11.7079 40.6699V11.7204C11.7079 8.65221 14.1952 6.16484 17.2635 6.16484C20.3317 6.16484 22.8191 8.65208 22.8191 11.7204V40.6699L24.6696 42.3262C27.0152 44.4255 28.3747 47.4013 28.3747 50.6094C28.3744 56.7458 23.3998 61.7204 17.2633 61.7204Z",
    fill: "#969C9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4846 22.832H20.0402V56.1654H14.4846V22.832Z",
    fill: "#969C9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2633 58.9421C21.8656 58.9421 25.5966 55.2111 25.5966 50.6087C25.5966 46.0064 21.8656 42.2754 17.2633 42.2754C12.6609 42.2754 8.92993 46.0064 8.92993 50.6087C8.92993 55.2111 12.6609 58.9421 17.2633 58.9421Z",
    fill: "#969C9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.aded989c6c24c2c87f5db02cb2e872cf.svg";
export { ForwardRef as ReactComponent };